import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeBadgeCounter, {moleculeBadgeCounterSizes} from '@s-ui/react-molecule-badge-counter'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'

import {BASE_CLASS_NAME} from './config.js'

export const MoleculeAccordionLabel = ({label, count, groupId, icon: Icon}) => {
  const {i18n} = useSuiContext()

  return (
    <div className={`${BASE_CLASS_NAME}-groupLabel`}>
      <div className={`${BASE_CLASS_NAME}-groupLabelContent`}>
        {count ? (
          <MoleculeBadgeCounter size={moleculeBadgeCounterSizes.SMALL}>
            <Icon aria-hidden role="presentation" size={ATOM_ICON_SIZES.medium} />
          </MoleculeBadgeCounter>
        ) : (
          <Icon aria-hidden role="presentation" size={ATOM_ICON_SIZES.medium} />
        )}
        <p className={`${BASE_CLASS_NAME}-groupLabelText`}>
          {label}
          {Boolean(count) && <VisuallyHidden>{i18n.t('COMMON.PLURALS.FILTER_APPLIED', count)}</VisuallyHidden>}
        </p>
      </div>
    </div>
  )
}

MoleculeAccordionLabel.propTypes = {
  groupId: PropTypes.string,
  label: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.elementType
}
